import { anatomyConstants } from "../../../constants/anatomyConstants";

function DistanceMeasuringModal({
  clearMeasurements,
  closePolygon,
  setIsMeasurementModalOpen,
  pathPoints,
  measureAngle,
  measureThickness,
  calculateMeshVolume,
  clearVolumeMeasurement,
  selectedMeshVolume,
  isVolumeSelectionMode,
  toggleVolumeSelectionMode,
  closeDistanceMeasuringMode,
  isMobile,
}) {
  // Check if mobile portrait (upside down) view
  const isMobilePortrait =
    isMobile &&
    typeof window !== "undefined" &&
    window.innerWidth < window.innerHeight;

  return (
    <div
      className={`absolute ${
        isMobilePortrait ? "bottom-20 left-2" : "bottom-1 left-28"
      } w-auto flex flex-col items-center z-50`}
    >
      <div className="relative flex flex-col items-center space-y-2 px-3 pt-7 pb-3 bg-white rounded-lg shadow-lg border border-gray-200 w-36">
        <button
          onClick={(e) => {
            e.stopPropagation();
            closeDistanceMeasuringMode();
          }}
          aria-label="Close"
          className="absolute top-2 right-2 w-5 h-5 rounded-full bg-gray-100 border border-[#0000001A] shadow-sm flex items-center justify-center text-gray-700 hover:bg-gray-200 z-10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <button
          title="Removes all placed points."
          onClick={(e) => {
            e.stopPropagation();
            clearMeasurements();
          }}
          className="w-full py-2 px-3 text-sm font-inter font-medium text-[#757575] bg-white rounded border border-[#0000001A] hover:bg-gray-100"
        >
          Clear Points
        </button>
        <button
          title="Connects the last point to the first point."
          onClick={(e) => {
            e.stopPropagation();
            closePolygon();
          }}
          disabled={pathPoints.length < 3}
          className={`w-full py-2 px-3 text-sm text-[#757575] font-inter font-medium rounded border border-[#0000001A] transition
    ${
      pathPoints.length >= 3
        ? "bg-white hover:bg-gray-100 cursor-pointer"
        : "bg-gray-200 cursor-not-allowed"
    }`}
        >
          Close Polygon
        </button>
        <button
          title="Measures the angle formed by three points."
          onClick={(e) => {
            e.stopPropagation();
            if (pathPoints.length !== 3) return;
            measureAngle();
          }}
          disabled={pathPoints.length !== 3}
          className={`w-full py-2 px-3 text-sm text-[#757575]  font-inter font-medium rounded border border-[#0000001A] transition
    ${
      pathPoints.length === 3
        ? "bg-white hover:bg-gray-100 cursor-pointer"
        : "bg-gray-200 cursor-not-allowed"
    }`}
        >
          Measure Angle
        </button>
        <button
          title={
            isVolumeSelectionMode
              ? "Click on any mesh to calculate its volume"
              : "Enable volume selection mode"
          }
          onClick={(e) => {
            e.stopPropagation();
            toggleVolumeSelectionMode();
          }}
          className={`w-full py-2 px-3 text-sm font-inter font-medium rounded border border-[#0000001A] transition ${
            isVolumeSelectionMode
              ? "bg-blue-100 text-blue-700 border-blue-300"
              : selectedMeshVolume !== null
              ? "bg-green-100 text-green-700 border-green-300"
              : "bg-white text-[#757575] hover:bg-gray-100"
          }`}
        >
          {isVolumeSelectionMode
            ? "Click Any Mesh for Volume"
            : selectedMeshVolume !== null
            ? `Volume: ${selectedMeshVolume.toFixed(2)} mm³`
            : "Select Mesh for Volume"}
        </button>
        {selectedMeshVolume !== null && (
          <button
            title="Clear volume measurement."
            onClick={(e) => {
              e.stopPropagation();
              clearVolumeMeasurement();
            }}
            className="w-full py-2 px-3 text-sm text-[#757575] font-inter font-medium rounded border border-[#0000001A] bg-red-50 hover:bg-red-100 cursor-pointer transition"
          >
            Clear Volume
          </button>
        )}
        {/* <button
          onClick={(e) => {
            e.stopPropagation();
            measureThickness();
          }}
          disabled={true}
          className="w-full py-2 px-3 text-sm font-medium md:text-xs md:font-normal text-white bg-purple-500 rounded hover:bg-purple-600"
        >
          Measure Thickness
        </button> */}
        <button
          title="Saves the current measurement."
          onClick={(e) => {
            e.stopPropagation();
            if (pathPoints.length < 2) return;
            setIsMeasurementModalOpen(true);
          }}
          disabled={pathPoints.length < 2}
          style={{
            "--main-color": anatomyConstants.mainColor,
            "--main-color-bold": anatomyConstants.mainColorBold,
          }}
          className={`w-full py-2 px-3 text-sm font-inter font-semibold text-white rounded transition
    ${
      pathPoints.length > 1
        ? "bg-[var(--main-color)] hover:bg-[var(--main-color-bold)] cursor-pointer border border-[#0000001A]"
        : "bg-gray-400 text-gray-200 cursor-not-allowed border border-[#0000001A]"
    }`}
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default DistanceMeasuringModal;
